import {
  Box
} from '@mui/material'

import { memo } from 'react'
import { type Coordinates, type TileEvent } from 'src/types'
import Sprite from './Sprite'
import useLightValue from 'src/hooks/useLightValue'
import { calculateLight } from 'src/utils/locationUtils'

const colorTransitions = {
  transition: 'color .2s, background-color .2s',
  transitionTimingFunction: 'ease-out'
}

const container = {
  ...colorTransitions,
  height: '32px',
  width: '32px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  textAlign: 'center'
}

interface TileProps {
  tileLight: number
  content: TileEvent | string
  handleClick: any
  color?: string
  backgroundColor?: string
  tileSize?: number
  y: number
  x: number
  spriteID?: string
}

const LocationEvent = memo(({ tileLight, content, handleClick, color, backgroundColor = 'transparent', tileSize = 32, y, x, spriteID }: TileProps) => {
  // @ts-expect-error
  const ui = content.ui ? content.ui : content
  const {light_radius, player_x, player_y } = useLightValue()

  const tileCoordinates: Coordinates = { x, y }
  const playerCoordinates: Coordinates = {
    x: player_x,
    y: player_y
  }

  const lightValue = calculateLight(playerCoordinates, tileCoordinates, tileLight, light_radius)
  const light = tileLight < lightValue ? tileLight : lightValue


  color = (
    ui === 'P'
      ? color
      : light < 3
        ? color ?? 'white'
        : light < 4
          ? '#9A8C98'
          : '#4A4E69'
  )

  const alwaysVisible = ['i', '↑', '↓', '←', '→', ' ', 'x']

  const propUI = (
    alwaysVisible.includes(ui) ? ui // if it's always visible
      : ui === '.' ? ' ' // if none or '.' renders empty tile
        : light < 3 ? ui
          : light < 4 ? '?'
            : ' '
  )

  // visibility
  const brightness = (
    light < 2
      ? 1
      : light < 3
        ? 0.8
        : light < 4
          ? 0.6
          : light < 5
            ? 0.4 
            : 0
  )


  return (
    <Box 
     // @ts-expect-error
      sx={
        { 
          ...container,
          backgroundColor,
          height: `${tileSize}px`,
          width: `${tileSize}px`,
          color,
          top: y * tileSize,
          left: x * tileSize,
          transform: spriteID ? `scale(${tileSize / 32})` : '',
          filter: `brightness(${spriteID ? brightness : 1})`
        }
      }
      onClick={handleClick} className='prop'
    >
      {
        spriteID ? (
          <Sprite spriteID={spriteID}/>
        ) : (
          <span style={{ textAlign: 'center', fontSize: `${tileSize}px` }}>{propUI}</span>
        )
      }
    </Box>
  )
})

export default LocationEvent
